/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: upload input
 | -------------------------------------------------------------
 |
 |  Functionality for upload input.
 |
*/

// 1. [√] get the uploaded file name from the input field
// 2. [√] display the uploaded file name
// 3. [√] add the option to remove the uploaded file
// 4. [√] add the option to upload a file via drag and drop
// 5. [future] add an image preview if an image is the uploaded file
// 6. [future] allow multiple file uploads
// 7. [future] make this work for multiple upload inputs

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

// get all upload inputs from the page and store it in an array
const uploadInputs = [...document.querySelectorAll('.input__upload')]
// get all the upload drop areas and store it in an array
const uploadDropareas = [...document.querySelectorAll('.upload__droparea')]

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

// create remove file link
const addRemoveFile = _ => {
  return '<a class="upload__remove">Verwijder bestand</a>'
}

// remove uploaded files
const removeFile = (currentUploadInput, input, files) => {
  const removeFileButton = currentUploadInput.querySelector('.upload__remove')

  removeFileButton.addEventListener('click', event => {
    input.value = ''
    files.innerHTML = ''
  })
}

// add active class to droparea
const addActiveClass = droparea => {
  droparea.classList.add('active')
}

// remove active class from droparea
const removeActiveClass = droparea => {
  droparea.classList.remove('active')
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

uploadInputs && uploadInputs.forEach(upload => {
  // add an event listener to every upload input to check whether the input field changes, in this case it's value because it's type is file
  upload.addEventListener('change', event => {
    // get the current target
    const currentTarget = event.target.parentNode
    const currentUploadInput = currentTarget.parentNode

    // get the uploaded filename
    const input = currentUploadInput.querySelector('[data-upload-input]')
    // get the area to show the uploaded file name
    const files = currentUploadInput.querySelector('.uploaded__files')

    // add the filename to the files area and strip any file paths
    files.innerHTML = `${input.value.split('\\').pop()} ${addRemoveFile()}`

    // remove files
    removeFile(currentUploadInput, input, files)
  })
})

// drag and drop events
uploadDropareas && uploadDropareas.forEach(droparea => {
  droparea.addEventListener('dragenter', event => {
    event.preventDefault()
    addActiveClass(droparea)
  })

  droparea.addEventListener('dragover', event => {
    event.preventDefault()
    addActiveClass(droparea)
  })

  droparea.addEventListener('dragleave', event => {
    event.preventDefault()
    removeActiveClass(droparea)
  })

  droparea.addEventListener('drop', event => {
    event.preventDefault()
    removeActiveClass(droparea)

    // get the current target
    const currentTarget = event.target.parentNode
    const currentUploadInput = currentTarget.parentNode

    // get the file data and file name
    const dt = event.dataTransfer
    const file = dt.files[0].name

    // get the uploaded filename
    const input = currentUploadInput.querySelector('[data-upload-input]')
    // get the area to show the uploaded file name
    const files = currentUploadInput.querySelector('.uploaded__files')
    // add the filename to the files area and strip any file paths
    files.innerHTML = `${file} ${addRemoveFile()}`
    // add file path to the input
    input.files = dt.files

    // remove files
    removeFile(currentUploadInput, input, files)
  })
})
